<template>
  <!-- Header -->
  <div class="header pork">
    <div class="container">
      <router-link class="site-logo" to="/Pork/PTCInfo">
        <img src="@/assets/image/pork_logo.png" alt="PTC" height="40">
        <h5 class="sub-text">破壳（中国）</h5>
      </router-link>
      <!-- Navigation -->
      <div class="header-navigation pull-right font-transform-inherit">
        <ul class="nav-list">
          <!-- 破壳信息 -->
          <li>
            <router-link to="/Pork/PTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">破壳信息</router-link>
            <!-- <ul class="dropdown-menu">
              <li><router-link :to="{ path: '/Pork/PorkSection', query: { sectionid: '_porknews', sectiontitle: '破壳新闻' }}">破壳新闻</router-link></li>
              <li><router-link :to="{ path: '/Pork/PorkSection', query: { sectionid: '_porkanalysis', sectiontitle: '破壳简析' }}">破壳简析</router-link></li>
            </ul> -->
          </li>
          <!-- 破壳数据 -->
          <li>
            <a class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">破壳数据</a>
            <ul class="dropdown-menu">
              <li><router-link to="/Pork/PTCData/PorkExportToChina" data-target="#" href="javascript:;">全球猪肉输华走势</router-link></li>
              <li><router-link to="/Pork/PTCData/GlobalPorkExports" data-target="#" href="javascript:;">全球猪肉出口格局</router-link></li>
              <li><router-link to="/Pork/PTCData/ChinaPorkImports" data-target="#" href="javascript:;">中国猪肉进口格局</router-link></li>
            </ul>
          </li>
          <!-- 准入工厂 -->
          <li>
            <router-link to="/Pork/PTCEst" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;">破壳工厂</router-link>
          </li>
          <!-- 必孚 -->
          <li>
            <router-link style="height: 84px; padding: 17px 12px;" to="/BTCInfo" class="dropdown-toggle" data-toggle="dropdown" data-target="#" href="javascript:;"><img src="@/assets/image/btc_btn.png" height="40px;"></router-link>
          </li>
          <!-- 搜索 -->
          <li class="menu-search">
            <span class="sep"/>
            <i class="fa fa-search search-btn" @click="handelClick"/>
            <div :class="{ showSearchBox: showSearch }" class="search-box">
              <form>
                <div class="input-group col-xs-5 pull-left" style="padding-right: 10px;">
                  <select v-model="country" type="text" class="form-control">
                    <option value="" label="所有国家"/>
                    <option v-for="item in countryOptions" :key="item.value" :value="item.value">{{ $t(`message['${item.value}']`) }}</option>
                    <option value="_other" label="其他"/>
                  </select>
                </div>
                <div class="input-group col-xs-7 pull-left">
                  <input v-model="keyWords" type="text" placeholder="请输入关键字" class="form-control">
                  <span class="input-group-btn">
                    <button class="btn btn-primary" style="background: #ff8888;" @click.prevent="handleSearch">搜索</button>
                  </span>
                </div>
              </form>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { porkcountrydata } from '@/utils/dictionary'
export default {
  name: 'Header',
  data() {
    return {
      country: '',
      showSearch: false,
      keyWords: ''
    }
  },
  computed: {
    isPork() {
      return this.$route.path.includes('Pork') || this.$route.path.includes('PTC')
    },
    path() {
      if (this.isPork) {
        return '/Pork/PorkSearch'
      } else {
        return '/search'
      }
    },
    countryOptions() {
      // const arr = []
      // let porkData = []
      // let beefData = []
      // porkData = porkData.concat(porkcountrydata)
      // beefData = beefData.concat(newsCountryData)
      // const all = this.intersection(porkData, beefData)
      // for (const i of all) {
      //   arr.push({ value: i })
      // }
      return porkcountrydata.map(v => {
        return { value: v }
      })
    }
  },
  created() {
    window.addEventListener('mouseup', this.handleMouseup)
  },
  methods: {
    handelClick() {
      this.showSearch = !this.showSearch
      return this.showSearch
    },
    handleMouseup(event) {
      if (this.showSearch && (event.target.nodeName !== 'INPUT' && event.target.nodeName !== 'SELECT')) {
        this.showSearch = false
      }
    },
    handleSearch() {
      if (this.country || this.keyWords) {
        this.$router.push({ path: this.path, query: { keywords: this.keyWords, country: this.country }})
        this.keyWords = ''
        this.country = ''
      }
    },
    intersection(arr1, arr2) {
      for (const item of arr1) {
        if (!arr2.includes(item)) {
          arr2.push(item)
        }
      }
      return arr2.sort()
    }
  }
}
</script>

<style>
.pork .header-navigation .dropdown-menu > li > a:hover {
  background: #ff8888!important;
}
.pork .header-navigation .dropdown-menu > li:first-child {
  border-top: 2px solid #ff8888!important;
}
</style>

<style scoped>
.header { margin-bottom: 8px!important; }
a { text-decoration: none; padding: 14px}
.site-logo { margin: 0 }
.site-logo:link    { color: #ff8888;}
.site-logo:visited { color: #ff8888;}
.site-logo:hover   { color: #ff8888;}
.site-logo:active  { color: #ff8888;}
.sub-text { font-size: 13px; margin: 2px 0 0 0; }
.nav-list { font-size:19px;}
.showSearchBox { display: inline!important }
.mobi-toggler { margin-left: 1px;}
</style>



// WEBPACK FOOTER //
// src/views/layout_pork/components/Navigation/index.vue